import Swiper from 'swiper';

export default class Slider {
  constructor(selector, config = {}, replaceAll = false) {
    this.sliderNode = document.querySelector(selector);

    if(this.sliderNode) {
      new Swiper(
        this.sliderNode,
        replaceAll ? config : Object.assign({}, Slider.getDefaultConfig(), config)
      );
    }

  }

  static getDefaultConfig() {
    return {
      direction: 'horizontal',
      slidesPerView: 1,
      loop: true,
      clickableState: true,
      autoplay: {
        delay: 3000,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 1,
        },
      },
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/slider.js